import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  DEFAULT_TEAM_ASSISTANT_THEME_ID,
  TEAM_ASSISTANT_COLOR_THEMES,
  applyTeamAssistantThemeToDocument,
  persistTeamAssistantThemeId,
  readStoredTeamAssistantThemeId,
} from '../utils/teamAssistantColorThemes';

const TeamAssistantThemeContext = createContext(null);

export function TeamAssistantThemeProvider({ children }) {
  const [themeId, setThemeIdState] = useState(() => readStoredTeamAssistantThemeId());

  useEffect(() => {
    applyTeamAssistantThemeToDocument(themeId);
  }, [themeId]);

  const setThemeId = useCallback((nextId) => {
    persistTeamAssistantThemeId(nextId);
    setThemeIdState(readStoredTeamAssistantThemeId());
  }, []);

  const value = useMemo(
    () => ({
      themeId,
      setThemeId,
      themes: TEAM_ASSISTANT_COLOR_THEMES,
    }),
    [themeId, setThemeId]
  );

  return (
    <TeamAssistantThemeContext.Provider value={value}>{children}</TeamAssistantThemeContext.Provider>
  );
}

export function useTeamAssistantTheme() {
  const ctx = useContext(TeamAssistantThemeContext);
  if (!ctx) {
    return {
      themeId: DEFAULT_TEAM_ASSISTANT_THEME_ID,
      setThemeId: persistTeamAssistantThemeId,
      themes: TEAM_ASSISTANT_COLOR_THEMES,
    };
  }
  return ctx;
}
